"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateEvaluator = void 0;
const context_entries_1 = require("@comunica/context-entries");
const Eval = __importStar(require("@comunica/utils-expression-evaluator"));
const RdfString = __importStar(require("rdf-string"));
/**
 * This is the base class for all aggregators.
 * NOTE: The wildcard count aggregator significantly differs from the others and overloads parts of this class.
 */
class AggregateEvaluator {
    evaluator;
    distinct;
    throwError;
    errorOccurred = false;
    variableValues;
    superTypeProvider;
    termTransformer;
    constructor(evaluator, distinct, throwError = false) {
        this.evaluator = evaluator;
        this.distinct = distinct;
        this.throwError = throwError;
        this.errorOccurred = false;
        this.superTypeProvider = evaluator.context.getSafe(context_entries_1.KeysExpressionEvaluator.superTypeProvider);
        this.termTransformer = new Eval.TermTransformer(this.superTypeProvider);
        this.variableValues = new Set();
    }
    emptyValueTerm() {
        return undefined;
    }
    /**
     * The spec says to throw an error when a set function is called on an empty
     * set (unless explicitly mentioned otherwise like COUNT).
     * However, aggregate error handling says to not bind the result in case of an
     * error. So to simplify logic in the caller, we return undefined by default.
     */
    emptyValue() {
        const val = this.emptyValueTerm();
        if (val === undefined && this.throwError) {
            throw new Eval.EmptyAggregateError();
        }
        return val;
    }
    /**
     * Base implementation of putBindings, that evaluates to a term and then calls putTerm.
     * The WildcardCountAggregator will completely discard this implementation.
     * @param bindings
     */
    async putBindings(bindings) {
        if (this.errorOccurred) {
            return;
        }
        try {
            const term = await this.evaluator.evaluate(bindings);
            if (!term || this.errorOccurred) {
                return;
            }
            // Handle DISTINCT before putting the term
            if (!this.distinct || !this.variableValues.has(RdfString.termToString(term))) {
                this.putTerm(term);
                if (this.distinct) {
                    this.variableValues.add(RdfString.termToString(term));
                }
            }
        }
        catch (error) {
            // Per SPARQL spec, aggregate functions ignore unbound variables.
            // An UnboundVariableError simply means this binding has no value for the aggregate variable,
            // so we skip it rather than treating it as an error (which would cause the entire aggregate to fail).
            if (error instanceof Eval.UnboundVariableError) {
                return;
            }
            this.safeThrow(error);
        }
    }
    async result() {
        if (this.errorOccurred) {
            return undefined;
        }
        return this.termResult();
    }
    safeThrow(err) {
        if (this.throwError) {
            throw err;
        }
        else {
            this.errorOccurred = true;
        }
    }
    termToNumericOrError(term) {
        if (term.termType !== 'Literal') {
            throw new Error(`Term with value ${term.value} has type ${term.termType} and is not a numeric literal`);
        }
        else if (!Eval.isSubTypeOf(term.datatype.value, Eval.TypeAlias.SPARQL_NUMERIC, this.superTypeProvider)) {
            throw new Error(`Term datatype ${term.datatype.value} with value ${term.value} has type ${term.termType} and is not a numeric literal`);
        }
        return this.termTransformer.transformLiteral(term);
    }
}
exports.AggregateEvaluator = AggregateEvaluator;
//# sourceMappingURL=AggregateEvaluator.js.map